export function PlaceListLoadingView() {
  return (
    <div className="module module-places">
      <div className="module-accent-rail" style={{ background: 'var(--color-border)' }} />
      <div className="module-content">
        <p className="empty-state-text">Loading places...</p>
      </div>
    </div>
  );
}
